import { apiClient } from "./api-client";
import type { VersionInfo } from "@/types/common";

export const versionApi = {
  async getVersionInfo(): Promise<VersionInfo> {
    return apiClient.get("/ReportManagement/GetReportingWebServiceVersionInfo");
  },
};
